import { SIDEBAR } from '@components/v2/layout/AppTemplate/appTemplate.consts';
import { NavItem } from '@components/v2/layout/AppTemplate/appTemplate.types';
import Icon from '@components/v2/ui/Icon/Icon';
import ListItemButton from '@components/v2/ui/List/ListItemButton';
import ListItemIcon from '@components/v2/ui/List/ListItemIcon';
import ListItemText from '@components/v2/ui/List/ListItemText';
import Tooltip from '@components/v2/ui/Tooltip/Tooltip';
import useDebounce from '../../../../../../../../hooks/useDebounce/useDebounce';
import { AppTemplateTestIds } from '../../../../../../../../utils/testIds/appTemplate.testIds';
import { useSidebarNavItemStyles } from './sidebarNavItem.styles';

interface SidebarNavItemProps {
  item: NavItem;
  isCollapsed: boolean;
  isActive: boolean;
  onClick: (item: NavItem) => void;
}

const SidebarNavItem = ({ item, isCollapsed, isActive, onClick }: SidebarNavItemProps) => {
  const { classes } = useSidebarNavItemStyles({ isCollapsed });
  const isTooltipEnabled = useDebounce(isCollapsed, SIDEBAR.transitionDuration);

  const linkProps = item.pathname ? { to: item.pathname } : {};
  const testId =
    item.testId ??
    (item.pathname ? `${AppTemplateTestIds.NAV_ITEM_PREFIX}${item.pathname}` : undefined);

  return (
    <Tooltip
      TooltipContent={item.label}
      placement="right"
      disabled={!isTooltipEnabled}
      delay={0}
      fullWidth
      tabIndex={-1}
    >
      <ListItemButton
        isActive={isActive}
        className={classes.button}
        testId={testId}
        onClick={() => onClick(item)}
        {...linkProps}
      >
        {item.icon && (
          <ListItemIcon className={classes.icon}>
            <Icon icon={item.icon} />
          </ListItemIcon>
        )}
        <ListItemText primary={item.label} className={classes.text} />
        {item.slots?.trailing && <span className={classes.trailing}>{item.slots.trailing}</span>}
      </ListItemButton>
    </Tooltip>
  );
};

export default SidebarNavItem;
